module.exports = __webpack_public_path__ + "static/media/dx-logo.1e1c96ec.svg";